module.exports = __webpack_public_path__ + "static/img/124.a06a409.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/124.png
// module id = VV4K
// module chunks = 0